<template>
  <v-app id="main">
    <v-content>
      <Navbar/>
      <router-view/>
      <modal-component v-if="!session"/>
      <component-chat v-if="session"/>
      <component-modalpresentation v-if="session"/>
      <component-modalpolicyprivacymodal/>
      <modal-tutorial/>
    </v-content>
  </v-app>
</template>

<script>
import { EventBus } from './helpers/eventbus/event-bus'


import modal from './components/Templates/Views/modal'
import policyprivacymodal from './components/Templates/Views/policyprivacymodal'

import Navbar from './components/Templates/Views/Navbar'
import tutorial from './components/Templates/Views/tutorial'
import presentation from './components/Templates/Views/presentation'
import chat from './components/Templates/Views/chat'

//import chatdesktop from './components/Templates/Views/chatdesktop'

import initVue from './helpers/initVue'

import {
    mapGetters,
    mapActions
} from 'vuex'


export default {
  name: 'App',
  computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
  }),
  data () {
    return {
      n:1,
      identity: null,
      session: false,
      token: null,
      chatdesktophidden: false,
      chatcontaineropen: false,
      userstorage: {}
    }
  },

  components:{
      'modal-component':modal,Navbar,'modal-tutorial':tutorial,
      'component-modalpresentation':presentation,
      'component-chat':chat,
      'component-modalpolicyprivacymodal':policyprivacymodal,
    },
  
  mounted(){
    if(document.domain === 'hiproyect.com'){
      window.location = 'https://www.hiproyect.com'
    }
    this.getidentity()
    if(screen.width > 1000 && this.session === true) {
      this.chatdesktophidden = false
    }
    let getdatauser = JSON.parse(localStorage.getItem('iden'))
				if(getdatauser){
					let isnewuser = getdatauser.statususer === 'newuser'
					if(isnewuser){
						EventBus.$emit('openpresentation')
					}
				}
    

    
  },

  methods:{
    getsessionuser(){
			let userisloged = JSON.parse(localStorage.getItem('user'))
			if(userisloged){
				this.session=true
			}else{
        this.session = false
      }
		},
      
    /*******************************************************
 * * Obteniendo la identidad para validar el token
 *******************************************************/
    getidentity(){
        this.identity = initVue.getIdentity().identity
        this.token = initVue.getIdentity().token
        this.session = initVue.isLogged(this.identity, this.token)
    },
    openchatcontainer(){
      let closechat = false
      let openingchatcontainer = this.chatdesktophidden === true && closechat === false
      if(openingchatcontainer){
        this.chatcontaineropen = true
      }
    },

    closechatcontainer(){
      let closechat = true
      let closingchatcontainer = this.chatdesktophidden === true && closechat
      if(closingchatcontainer){
        this.chatcontaineropen = false
      }
    }
  }
}
</script>
